import { Snack, Snackbar, SnackButton, Typography, useSnackbar } from 'fronton-react';
import React from 'react';
import { Breakpoint } from 'types/utils';
import { AlertInfoOutline } from 'common/components/monochrome-icons';
import { Styles } from './styles';
import { ErrorSnackContent, ReviewFormFieldError } from '../../types';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from '@navi-toolbox/hooks';

export const ErrorsSnackbar: React.FC<{
  snacksContentConfig: Map<string | undefined, ErrorSnackContent>;
  breakpoint: Breakpoint;
  errors: ReviewFormFieldError[];
  onReviewPublicationErrorShown?: (params: { ruText: string }) => void;
}> = ({ snacksContentConfig, breakpoint, errors, onReviewPublicationErrorShown }) => {
  const { state, addSnack, removeSnack } = useSnackbar();
  const { t } = useTranslation();
  useEffectOnce(() => {
    errors
      ?.filter((errRecord) => snacksContentConfig.has(errRecord.errorKey))
      .map((errRecord) => {
        const snackContent = snacksContentConfig.get(errRecord.errorKey);
        const {
          title,
          message,
          hideAfter = 0,
          hasButton,
        } = snackContent ?? {
          title: '',
          message: errRecord.message,
        };
        const snackId = `snack--${errRecord.errorKey}`;
        if (onReviewPublicationErrorShown) onReviewPublicationErrorShown({ ruText: message });
        addSnack({
          id: snackId,
          title,
          message,
          hideAfter,
          hasButton,
        });
      });
  });
  return (
    <Snackbar verticalPosition={breakpoint === 'mobile' || breakpoint === 'tablet' ? 'top' : 'bottom'}>
      {state.map(({ id, title, message, hideAfter, hasButton }) => {
        return (
          <Snack
            autoHideTimer={hideAfter}
            key={id}
            id={id}
            header={title}
            paragraph={message}
            variant="error"
            wideButton
            icon={<AlertInfoOutline className={Styles.alertIcon} />}
          >
            <React.Fragment key=".0">
              {hasButton && (
                <SnackButton onClick={() => removeSnack(id)}>
                  <Typography size="body_accent" variant="s">
                    {t('reviews.form.ui.good')}
                  </Typography>
                </SnackButton>
              )}
            </React.Fragment>
          </Snack>
        );
      })}
    </Snackbar>
  );
};
